// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { sparseLocationSchema } from '@/sparse/api/types';
import { z } from 'zod';

const zonesResponseSchema = z
  .object({
    data: z.array(sparseLocationSchema),
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({
    ...response,
    zones: data,
  }));

type ZonesResponse = z.infer<typeof zonesResponseSchema>;

export async function getZones(
  locationKey: string,
  options?: { includeArchived?: boolean }
): Promise<ZonesResponse> {
  const url = `/v1/location/SITE/${locationKey}/zones`;
  const params = options?.includeArchived ? { archived: 'all' } : undefined;
  const response = await api.get(url, { params });

  return parseResponse(zonesResponseSchema, response.data, {
    schemaName: 'Zones',
    endpoint: url,
  });
}
